// extracted by mini-css-extract-plugin
export default {"button":"NormalButton_button__CEMaP","disabled":"NormalButton_disabled__K9Tf6"};